<template>
  <section>
    <div class="section-inner">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-lg-6 copy">
            <div class="element xs centered">
              <slot></slot>
            </div>
          </div>
          <div class="col-xs-12 col-lg-6 img">
            <img class="hero" src="~@/images/hero.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'team-wrap',
  data () {
    return {}
  }
}
</script>

<style scoped lang="stylus" src="./team-wrap.styl" >



// WEBPACK FOOTER //
// src/components/team-wrap/team-wrap.vue